import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import { FaPaperPlane} from 'react-icons/fa'
import Track from './track';

class Participant extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
        super(props);
      
        const existingPublications = Array.from(this.props.participant.tracks.values());
        const existingTracks = existingPublications.map(publication => publication.track);
        const nonNullTracks = existingTracks.filter(track => track !== null)
      
        this.state = {
          tracks: nonNullTracks
        }

        this.HandleChange = (e) =>{
            this.setState({[e.target.name]: e.target.value});
        };
    }

    componentDidMount() {
        if (!this.props.localParticipant) {
          this.props.participant.on('trackSubscribed', track => this.addTrack(track));
        }
    }

    addTrack(track) {
        this.setState({
          tracks: [...this.state.tracks, track]
        });
    }


    render() {
      var window = this.props.window

      return (
        <div id={this.props.participant.identity} style={{position: 'relative', marginBottom: '180px'}}>
            <div class={window+'_view'} >
              { 
                this.state.tracks.map(track => 
                <Track key={track} filter={this.state.filter} track={track}/>)
              }
            </div>
            <div style={{backgroundColor: '#5A6268', borderRadius: '20px', top: '25px', left: '20px', position: 'absolute'}}>
              <h6 style={{color: '#ffffff', margin: '5px', fontSize: '12px'}}>
                { this.props.participant.identity}
              </h6>
            </div>
            <br/>
        </div>
      );
    }

  };
  
  export default withCookies(Participant);